
import { Component, Mixins } from "vue-property-decorator";
import { TagsViewModule } from "@/store/modules/tags-view";
import BackToTop from "@/components/back-to-top/index.vue";
import { SettingsModule } from "@/store/modules/settings";
import { AppModule } from "@/store/modules/app";
import { UserModule } from "@/store/modules/user";
import Navigation from "./Navigation/navigation.vue";
import WeException from "@/components/We/exception";
import fackClickOutSide from "@/utils/fackClickOutSide";
import WeMessage from "@/views/chat/message.vue";
import { pageLayout } from "../page-layout";

@Component({
    name: "AppMain",
    components: {
        BackToTop,
        Navigation,
        WeException,
        WeMessage,
    },
})
export default class extends Mixins(fackClickOutSide) {
    get presentation() { return pageLayout(this.$route.path, this.$route.meta && this.$route.meta.title || '平台管理'); }
    get cachedViews() {
        // console.log(TagsViewModule.cachedViews);
        return TagsViewModule.cachedViews;
    }

    get key() {
        return this.$route.path;
    }

    get fixHeader() {
        return SettingsModule.fixedHeader;
    }

    get controlMsg() {
        return AppModule.requestMsg;
    }

    get revOrderShow() {
        return UserModule.receiveOrderTag;
    }

    changeVal() {
        AppModule.SET_REQUEST_MSG({
            code: 100,
            msg: "加载中",
        });

        TagsViewModule.delAllCachedViews();
        (this as any).$bus.$emit(this.$route.path);
    }
}
